import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import values from '../../node_modules/ramda/es/values.js';
import Theme from '../../Theme/index.js';

var _templateObject;
var size = {
  sm: 14,
  md: 16,
  lg: 18
};
var weight = {
  light: 300,
  normal: 500,
  bold: 600
};
var Paragraph = styled.p(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n"])), function (props) {
  return props.color || Theme.colors.primary;
}, Theme.fonts.Montserrat, function (props) {
  return "".concat(size[props.size] || size.md, "px");
}, function (props) {
  return weight[props.fw] || weight.light;
});
Paragraph.displayName = "Paragraph";
Paragraph.propTypes = {
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  fw: PropTypes.oneOf(["light", "normal", "bold"]),
  color: PropTypes.oneOf(values(Theme.colors))
};

export { Paragraph as default, size, weight };
